import MaterialButton from "../../../../components/MaterialButton";
import { MdEdit } from "react-icons/md";
import { MdOutlineLocationCity } from "react-icons/md";
import { GrFormView } from "react-icons/gr";
import { FaEye } from "react-icons/fa";
import { AiFillDelete } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { IconButton, Tooltip } from "@mui/material";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import StatusChip from "./StatusChip";
import { FaUserTie, FaPhoneAlt } from "react-icons/fa";
import RoleAccess from "../../../function/RoleAccess";

const ProductDisplayProduct = ({
  agreedProducts,
  address,
  isLoading,
  setAgreenProductOpen,
  setRemarksOpen,
  setDatas,
  handleDeleteMall,
  mallId,
  tabValue,
  handleRecoildialog,
  contactPerson,
  contactNumber,
}) => {
  const navigate = useNavigate();
  const handleOpenRemarks = (value) => {
    setRemarksOpen(true);
    setDatas(value);
  };

  const handleAgreedOpen = (value) => {
    setAgreenProductOpen(true);
    setDatas(value);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 0px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "10px 0px",
          }}
        >
          <div className="productmallAdressbox" title="Market Address">
            <MdOutlineLocationCity className="productmall-icon" />
            <address>{address}</address>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className="productmallcontactbox" title="contact Person">
            <FaUserTie className="productmall-icon" />
            <p>{contactPerson}</p>
          </div>
          <div className="productmallcontactbox" title="contact Number">
            <FaPhoneAlt className="productmall-icon" />
            <p>{contactNumber}</p>
          </div>
        </div>
      </div>
      <div className="product-table-container">
        <table className="product-table">
          <thead>
            <tr>
              <th>S.no</th>
              <th>Product Name</th>
              <th>Category</th>

              <th>Quantity</th>
              <th>Actual Qty</th>

              <th>Retail Price</th>
              <th>Remarks</th>
              <th>Approve Status</th>
           
                <th>Action</th>
           
            </tr>
          </thead>

          <tbody>
            {!isLoading &&
              agreedProducts?.map((item, index) => (
                <tr
                  key={item.id}
                  className={
                    item?.reconciliation?.status
                      ? "status-true"
                      : "status-false"
                  }
                >
                  <td>{index + 1}</td>
                  <td>{item?.product.productName}</td>
                  <td>{item.product?.productCategory}</td>

                  <td>{item.quantity}</td>
                  <td>{item?.reconciliation?.actualQuantity || "N/A"}</td>

                  <td>{item?.reconciliation?.retailPrice || "N/A"}</td>
                  <td>
                    <GrFormView
                      style={{ cursor: "pointer" }}
                      onClick={() => handleOpenRemarks(item)}
                    />
                  </td>
                  <td>
                    {(
                      <StatusChip
                        status={
                          item?.remark?.approvedStatus?.toLowerCase() ==
                          "approved"
                            ? 2
                            : item?.remark?.approvedStatus?.toLowerCase() ==
                              "pending"
                            ? 1
                            : item?.remark?.approvedStatus?.toLowerCase() ==
                              "rejected"
                            ? 3
                            : null
                        }
                      />
                    ) || "N/A"}
                  </td>
                  <td>
                      <RoleAccess
                modelName="Product Display Compliance Screen"
                component="ViewProductCompliance"
              >
                <IconButton onClick={() => handleAgreedOpen(item)}>
                      <Tooltip title={"View"}>
                        <FaEye />
                      </Tooltip>
                    </IconButton>
              </RoleAccess>
                   

                    {tabValue == "myentry" && (
                      <>
                        <IconButton
                          onClick={() => handleRecoildialog("reconcile", item)}
                        >
                          <Tooltip title={"Reconcile"}>
                            <SyncAltIcon sx={{ color: "#1E88E5" }} />
                          </Tooltip>
                        </IconButton>

                        <IconButton
                          onClick={() =>
                            handleRecoildialog("remark", {
                              ...item,
                              mallEntryId: mallId,
                            })
                          }
                        >
                          <Tooltip title={"Remarks"}>
                            <NoteAltIcon sx={{ color: "#AAA800" }} />
                          </Tooltip>
                        </IconButton>
                      </>
                    )}
                  </td>
                </tr>
              ))}

            {isLoading &&
              [...Array(6)].map((_, index) => (
                <tr key={index}>
                  {Array(10)
                    .fill("")
                    .map((_, i) => (
                      <td key={i}>
                        <div className="skeleton skeleton-text"></div>
                      </td>
                    ))}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductDisplayProduct;
